import React from 'react';

import PropTypes from 'prop-types';

import { useContext as useUsersContext } from 'components/Users/Context';

import useMemberCyclePayments from 'components/Common/VoluntaryBenefits/Hooks/useMemberCyclePayments';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import DataTable from 'react-data-table-component';

import paymentColumns from './Payments/columns';

import TotalRow from './Payments/TotalRow';
import Download from './Payments/Download';

export default function Payments({ cycle }) {
  const { state: stateUsers } = useUsersContext();

  const member = stateUsers.user.attributes.specific;

  const payments = useMemberCyclePayments({
    memberId: member.id,
    cycleId: cycle.id,
  });

  if (payments === null) {
    return (
      <LoadingPlaceholder text="Loading..." className="py-5" />
    );
  }

  return (
    <div className="row justify-content-center">
      <div className="col-md-8">
        <DataTable
          title=""
          columns={paymentColumns}
          data={payments}
          noDataComponent="There are no records to display."
          persistTableHead
        />
        {payments.length > 0 && <TotalRow cycle={cycle} payments={payments} />}

        {payments.length > 0 && <Download cycle={cycle} />}
      </div>
    </div>
  );
}

Payments.propTypes = {
  cycle: PropTypes.object.isRequired,
};
